import Decimal from 'decimal.js';
import { PriceObject } from './offer';

export type WalletTransactionType = 'credit' | 'withdraw';
export type WalletTransactionStatus = 'pending' | 'validated' | 'rejected';

export class WalletBalance {
    balance: Decimal;
    pendingBalance: Decimal;
    currency: string;

    constructor(obj?: any) {
        this.balance = new Decimal(obj?.balance ?? 0);
        this.pendingBalance = new Decimal(obj?.pendingBalance ?? 0);
        this.currency = obj?.currency ?? 'TRY';
    }

    get balancePrice(): PriceObject {
        return { price: this.balance, currency: this.currency };
    }

    get pendingBalancePrice(): PriceObject {
        return { price: this.pendingBalance, currency: this.currency };
    }
}

export class WalletTransaction {
    id: number;
    type: WalletTransactionType;
    amount: Decimal;
    currency: string;
    status: WalletTransactionStatus;
    orderRef?: string;
    createdAt?: string;

    constructor(obj?: any) {
        if (obj) {
            Object.assign(this, obj);
            this.amount = new Decimal(obj.amount ?? 0);
        }
    }

    get amountPrice(): PriceObject {
        return { price: this.amount, currency: this.currency };
    }
}
